import { createReducer } from '@reduxjs/toolkit';
import { appAction } from './action';
import { AppState } from './model';

const initialState: AppState = {
  opened: false,
  menu: [],
  appLoading: false,
  resolution: {
    width: 0,
    height: 0,
  },
};

const appReducer = createReducer(initialState, (builder) =>
  builder
    .addCase(appAction.setMenu, (state, action) => {
      state.opened = action.payload;
    })
    .addCase(appAction.openMenu, (state, action) => {
      state.menu = action.payload;
    })
    .addCase(appAction.setAppLoading, (state, action) => {
      state.appLoading = action.payload;
    })
    .addCase(appAction.setResolution, (state, action) => {
      state.resolution = action.payload;
    })
);

export default appReducer;
